import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Layout/Header";
import Footer from "@/components/Layout/Footer";
import FloatingWhatsApp from "@/components/Layout/FloatingWhatsApp";
import MobileActionBar from "@/components/Layout/MobileActionBar";
import RegionPopup from "@/components/RegionPopup";
import { SettingsProvider } from "@/context/SettingsContext";
import { AuthProvider } from "@/context/AuthContext";

import Home from "@/pages/Home";
import { ProductsList, ProductDetail } from "@/pages/Products";
import { ProjectsList, ProjectDetail } from "@/pages/Projects";
import { GlobalPresence, Contact } from "@/pages/GlobalContact";
import { About, Manufacturing, Installation, Industries, Quality, Warranty, Resources, News } from "@/pages/Info";
import { AdminLogin, AdminLayout, AdminDashboard, AdminProducts, AdminProjects, AdminBranches, AdminClients, AdminNews, AdminDocuments, AdminEnquiries, AdminSettings, AdminAccount, AdminUsers, AdminLegal } from "@/pages/Admin";
import Status from "@/pages/Status";
import Legal from "@/pages/Legal";

function PublicShell() {
  const loc = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [loc.pathname]);
  return (
    <>
      <Header/>
      <Outlet/>
      <Footer/>
      <FloatingWhatsApp/>
      <MobileActionBar/>
      <RegionPopup/>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SettingsProvider>
            <Routes>
              <Route element={<PublicShell/>}>
                <Route path="/" element={<Home/>}/>
                <Route path="/about" element={<About/>}/>
                <Route path="/products" element={<ProductsList/>}/>
                <Route path="/products/:slug" element={<ProductDetail/>}/>
                <Route path="/projects" element={<ProjectsList/>}/>
                <Route path="/projects/:id" element={<ProjectDetail/>}/>
                <Route path="/industries" element={<Industries/>}/>
                <Route path="/manufacturing" element={<Manufacturing/>}/>
                <Route path="/installation" element={<Installation/>}/>
                <Route path="/quality" element={<Quality/>}/>
                <Route path="/warranty" element={<Warranty/>}/>
                <Route path="/resources" element={<Resources/>}/>
                <Route path="/news" element={<News/>}/>
                <Route path="/global-presence" element={<GlobalPresence/>}/>
                <Route path="/global" element={<GlobalPresence/>}/>
                <Route path="/contact" element={<Contact/>}/>
                <Route path="/status" element={<Status/>}/>
                <Route path="/:page(terms|privacy)" element={<Legal/>}/>
              </Route>
              <Route path="/admin/login" element={<AdminLogin/>}/>
              <Route path="/admin" element={<AdminLayout/>}>
                <Route index element={<AdminDashboard/>}/>
                <Route path="products" element={<AdminProducts/>}/>
                <Route path="projects" element={<AdminProjects/>}/>
                <Route path="branches" element={<AdminBranches/>}/>
                <Route path="clients" element={<AdminClients/>}/>
                <Route path="news" element={<AdminNews/>}/>
                <Route path="documents" element={<AdminDocuments/>}/>
                <Route path="enquiries" element={<AdminEnquiries/>}/>
                <Route path="settings" element={<AdminSettings/>}/>
                <Route path="account" element={<AdminAccount/>}/>
                <Route path="users" element={<AdminUsers/>}/>
                <Route path="legal" element={<AdminLegal/>}/>
              </Route>
            </Routes>
          </SettingsProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
